<template>
  <AdminSectionContainer>
    <h2>All RSS Sources</h2>
    <div>
      <h3 class="my-3" style="font-weight: 500;">
        Existing Sources
      </h3>
      <v-btn
        class="pa-3 ma-3"
        @click.stop="fetch"
      >
        Fetch (May be long)
      </v-btn>
      <v-progress-circular
        v-if="fetching"
        indeterminate
        color="primary"
      />
      <v-card
        v-if="allSources.length !== 0"
        elevation="2"
        class="pa-3 my-3"
      >
        <div class="scrollbar">
          <div
            v-for="source in allSources"
            :key="source.id"
          >
            <v-card
              outlined
              elevation="1"
              class="pa-2 d-flex align-center"
            >
              <v-icon :color="(source.active) ? 'green' : 'grey'">
                circle
              </v-icon>
              <span class="ml-2 text-ellipsis source-title">
                {{ source.title }}
              </span>
              <span class="ml-2 text-ellipsis source-domain">
                {{ source.rssUrl }}
              </span>
              <v-spacer />
            </v-card>
          </div>
        </div>
      </v-card>
    </div>
  </AdminSectionContainer>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { types } from '@/store/rootTypes';
import AdminSectionContainer from './AdminSectionContainer';

export default {
  name: 'RssSourceList',
  components: { AdminSectionContainer },
  data() {
    return {
      fetching: false,
    };
  },
  computed: {
    ...mapGetters({
      allSources: types.sources.getters.allSources,
    }),
  },
  methods: {
    ...mapActions({
      fetchAllSources: types.sources.actions.fetchAllSources,
    }),
    async fetch() {
      this.fetching = true;
      await this.fetchAllSources();
      this.fetching = false;
    },
  },
};
</script>

<style scoped>
.form-text-field {
  min-width: 400px;
}
.clickable-url {
  font-size: 14px;
  font-weight: 300;
}
.clickable-url:hover {
  cursor: pointer;
  text-decoration: underline;
  color: blue;
}
.source-title {
  max-width: 50%;
  font-size: 16px;
  font-weight: 500;
}
.source-domain {
  font-size: 12px;
}
.text-ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
/* SCROLLBAR CSS */
.scrollbar {
  overflow-y: auto;
  max-height: 500px;
  margin: 6px;
  padding: 6px;
}
::-webkit-scrollbar {
  width: 12px;
}
::-webkit-scrollbar-track {
  border-radius: 6px;
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background: #c1c1c1;
}
::-webkit-scrollbar-thumb:hover {
  background: grey;
}
</style>
